import { styled } from "@mui/material";
import pxToRem from "theme/base/pxToRem";

export const widthCheckBox = 50;
export const heightFooter = 70;

export const TableWrapper = styled("div")<{ isBorderTable: boolean }>`
  position: relative; //needed for sticky header
  overflow: auto; //our scrollable table container
  width: 100%;
  height: 100%;
  border: ${({ theme, isBorderTable }) =>
    isBorderTable ? `1px solid ${theme.palette.stroke.strokeDefault}` : "none"};
  border-radius: ${({ theme, isBorderTable }) =>
    isBorderTable ? theme.borders.borderRadius.xl_12 : 0};
  table {
    width: 100%;
    height: 100%;
    position: relative;
    border-collapse: collapse;
    thead {
      position: sticky;
      top: 0;
      z-index: 1;
      tr {
        background-color: ${({ theme }) => theme.palette.background.bgBase};
      }
    }
    tr {
      display: flex;
      width: 100%;
      // height: ${pxToRem(42)};
      :first-child {
        th : {
          :first-child {
            border-top-left-radius: ${({ theme }) =>
              theme.borders.borderRadius.xl_12};
          }
        }
      }
      th {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        overflow: hidden;
        border-right: 1px solid
          ${({ theme }) => theme.palette.stroke.strokeDefault};
        background-color: ${({ theme }) => theme.palette.background.bgBase};
        font-size: ${({ theme }) => theme.typography.size.sm_14};
        padding: 0 ${pxToRem(16)};

        .can-sort {
          cursor: pointer;
          display: flex;
          flex: 1;
        }

        :last-child {
          border-top-right-radius: ${({ theme }) =>
            theme.borders.borderRadius.xl_12};
          border-right: none;
        }
      }
      td {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        overflow: hidden;
        color: ${({ theme }) => theme.palette.text.textPrimary};
        font-size: ${({ theme }) => theme.typography.size.sm_14};
        border-right: 1px solid
          ${({ theme }) => theme.palette.stroke.strokeDefault};
        padding: 0 ${pxToRem(16)};
        :last-child {
          border-right: none;
        }
      }
    }
    tfoot {
      position: sticky;
      bottom: 0;
      z-index: 1;
      background-color: orange;
    }
  }
`;
